import { format, parseISO } from 'date-fns';
import { DateRange } from 'react-day-picker';

export const DEFAULT_CHAT_AGENT_ID = '000000000000000000000000';

export function formatNumber(value: number) {
  return value.toLocaleString();
}

/**
 * Parses the calendar-date portion of an ISO value without applying a timezone
 * offset. The usage API returns `period.end` as an end-of-day UTC timestamp
 * (e.g. `2026-09-10T23:59:59Z`); parsing that directly shifts the day forward in
 * timezones ahead of UTC, which made the range read one day into the future.
 */
export function parseDateOnly(value: string) {
  return parseISO(value.slice(0, 10));
}

export function formatShortDate(value: string) {
  return format(parseDateOnly(value), 'MMM dd');
}

export function formatWindow(start: string, end: string) {
  return `${format(parseDateOnly(start), 'MMM dd')} - ${format(parseDateOnly(end), 'MMM dd, yyyy')}`;
}

export function formatRangeLabel(range: DateRange | undefined, selectRangeLabel: string) {
  if (!range?.from) return selectRangeLabel;
  if (!range.to) return format(range.from, 'MMM dd, yyyy');
  return `${format(range.from, 'MMM dd')} - ${format(range.to, 'MMM dd, yyyy')}`;
}

export function getRatio(prompt: number, completion: number) {
  if (!prompt) return '—';
  return `${(completion / prompt).toFixed(3)}x`;
}

export function getAverage(total: number, count: number) {
  if (!count) return '—';
  return formatNumber(Math.round(total / count));
}

export function getUserLabel(userId: string | null | undefined) {
  if (!userId) return 'unknown';
  if (userId.length <= 16) return userId;
  return `${userId.slice(0, 8)}...${userId.slice(-8)}`;
}

export function getErrorMessage(error: unknown, fallback: string) {
  const httpError = error as {
    error?: { detail?: string; message?: string; error?: string };
    message?: string;
  };

  return (
    httpError?.error?.detail ??
    httpError?.error?.message ??
    httpError?.error?.error ??
    httpError?.message ??
    fallback
  );
}
